module.exports = __webpack_public_path__ + "static/media/right-arrow-circle.27b243f5.svg";